import { useDataSource } from '../lib/dataSource'

type LifeSpace = 'personal' | 'work' | 'home'

/**
 * Count behind the sidebar's "Demnächst" badge and the Dock badge: tasks of
 * this lifeSpace planned (start date) for today or the next seven days, excluding paused, completed and deleted ones (`isPlannedWithinNextWeek`).
 *
 * Reads live from the data source (Dexie in the app), so the badge follows edits immediately.
 * The previous implementation counted over `useGlobalTasks()`, which mirrors
 * raw Supabase realtime rows (snake_case `due_date`) while the loop read
 * camelCase `dueDate` — the badge was therefore always 0, and it never
 * filtered by lifeSpace either. Returns 0 while the query is loading.
 */
export function useUpcomingTaskCount(lifeSpace: LifeSpace): number {
  return useDataSource().useUpcomingTaskCount(lifeSpace)
}
